/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Release_Date_LabelInputs */



/**
* | output |
* | --- |
* | "Release date" |
*
* @param {Promo_Release_Date_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_release_date_label = /** @type {((inputs?: Promo_Release_Date_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Release_Date_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Date de sortie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha de lanzamiento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Data de lançamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data di uscita")
	return /** @type {LocalizedString} */ ("Release date")
});